(() => {
  const buttons = [...document.querySelectorAll('[data-filter]')];
  const search = document.querySelector('[data-search]');
  const gridItems = [...document.querySelectorAll('[data-article-grid] .article-item')];
  const empty = document.querySelector('.guide-empty');
  const count = document.getElementById('article-count');
  const recommendedGrid = document.querySelector('.highlight-grid');
  const recommendedPrev = document.querySelector('[data-recommended-prev]');
  const recommendedNext = document.querySelector('[data-recommended-next]');
  const recommendedDots = [...document.querySelectorAll('[data-recommended-dot]')];
  let active = 'all';
  let recommendedAnimating = false;
  let recommendedIndex = 0;

  const updateRecommendedDots = () => recommendedDots.forEach((dot, index) => {
    const selected = index === recommendedIndex;
    dot.setAttribute('aria-selected', selected ? 'true' : 'false');
    dot.tabIndex = selected ? 0 : -1;
  });

  const update = () => {
    const query = (search?.value || '').trim().toLowerCase();
    gridItems.forEach(item => {
      const categories = (item.dataset.category || '').split(' ');
      const text = (item.dataset.searchText || item.textContent).toLowerCase();
      item.hidden = !((active === 'all' || categories.includes(active)) && (!query || text.includes(query)));
    });
    const visible = gridItems.filter(item => !item.hidden).length;
    if (count) count.textContent = visible === 9 ? 'Showing all 9 articles' : `Showing ${visible} article${visible === 1 ? '' : 's'}`;
    if (empty) empty.hidden = visible !== 0;
    const recommendedCanMove = recommendedGrid?.children.length > 1;
    if (recommendedPrev) recommendedPrev.disabled = !recommendedCanMove;
    if (recommendedNext) recommendedNext.disabled = !recommendedCanMove;
    recommendedDots.forEach(dot => { dot.disabled = !recommendedCanMove; });
  };

  buttons.forEach(button => button.addEventListener('click', () => {
    active = button.dataset.filter;
    buttons.forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
    update();
  }));
  search?.addEventListener('input', update);
  document.querySelector('[data-clear]')?.addEventListener('click', () => {
    active = 'all';
    if (search) search.value = '';
    buttons.forEach(item => { const selected = item.dataset.filter === 'all'; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', selected ? 'true' : 'false'); });
    update();
  });
  const rotateRecommended = direction => {
    if (!recommendedGrid || recommendedGrid.children.length < 2 || recommendedAnimating) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      if (direction === 'next') recommendedGrid.append(recommendedGrid.firstElementChild);
      else recommendedGrid.prepend(recommendedGrid.lastElementChild);
      recommendedIndex = direction === 'next' ? (recommendedIndex + 1) % recommendedDots.length : (recommendedIndex - 1 + recommendedDots.length) % recommendedDots.length;
      updateRecommendedDots();
      return;
    }

    recommendedAnimating = true;
    recommendedPrev.disabled = true;
    recommendedNext.disabled = true;
    const duration = 420;
    const gap = Number.parseFloat(getComputedStyle(recommendedGrid).columnGap) || 0;
    const original = direction === 'next' ? recommendedGrid.firstElementChild : recommendedGrid.lastElementChild;
    const clone = original.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a,button,input').forEach(item => item.setAttribute('tabindex', '-1'));

    const finish = () => {
      if (!clone.isConnected) return;
      if (direction === 'next') recommendedGrid.append(original);
      else recommendedGrid.prepend(original);
      clone.remove();
      recommendedGrid.style.transition = 'none';
      recommendedGrid.style.transform = 'translate3d(0,0,0)';
      recommendedGrid.getBoundingClientRect();
      recommendedGrid.style.removeProperty('transition');
      recommendedGrid.style.removeProperty('transform');
      recommendedAnimating = false;
      recommendedPrev.disabled = false;
      recommendedNext.disabled = false;
      recommendedDots.forEach(dot => { dot.disabled = false; });
      recommendedIndex = direction === 'next' ? (recommendedIndex + 1) % recommendedDots.length : (recommendedIndex - 1 + recommendedDots.length) % recommendedDots.length;
      updateRecommendedDots();
    };

    if (direction === 'next') {
      recommendedGrid.append(clone);
      const step = original.getBoundingClientRect().width + gap;
      requestAnimationFrame(() => {
        recommendedGrid.style.transition = `transform ${duration}ms cubic-bezier(.22,1,.36,1)`;
        recommendedGrid.style.transform = `translate3d(${-step}px,0,0)`;
      });
    } else {
      recommendedGrid.prepend(clone);
      const step = original.getBoundingClientRect().width + gap;
      recommendedGrid.style.transition = 'none';
      recommendedGrid.style.transform = `translate3d(${-step}px,0,0)`;
      recommendedGrid.getBoundingClientRect();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        recommendedGrid.style.transition = `transform ${duration}ms cubic-bezier(.22,1,.36,1)`;
        recommendedGrid.style.transform = 'translate3d(0,0,0)';
      }));
    }
    window.setTimeout(finish, duration + 40);
  };
  recommendedPrev?.addEventListener('click', () => rotateRecommended('prev'));
  recommendedNext?.addEventListener('click', () => rotateRecommended('next'));
  recommendedDots.forEach(dot => dot.addEventListener('click', () => {
    const target = Number(dot.dataset.recommendedDot);
    if (target === recommendedIndex || recommendedAnimating) return;
    const forward = (target - recommendedIndex + recommendedDots.length) % recommendedDots.length;
    rotateRecommended(forward === 1 ? 'next' : 'prev');
  }));
  updateRecommendedDots();

  // Article share: the fourth button copies the article URL. The icon flips to a
  // check and the status region announces it, then both reset after 2s.
  const copyButton = document.querySelector('[data-copy-article]');
  const copyStatus = document.querySelector('[data-copy-status]');
  // execCommand fallback for browsers or embeds where the async clipboard API is
  // missing or denied by permissions policy.
  const copyWithSelection = text => new Promise((resolve, reject) => {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.append(field);
    field.select();
    const ok = document.execCommand('copy');
    field.remove();
    ok ? resolve() : reject(new Error('copy failed'));
  });
  const copyText = text => {
    if (!navigator.clipboard || !window.isSecureContext) return copyWithSelection(text);
    return navigator.clipboard.writeText(text).catch(() => copyWithSelection(text));
  };
  let copyTimer;
  copyButton?.addEventListener('click', () => {
    const url = copyButton.dataset.url || window.location.href.split('#')[0];
    const icon = copyButton.querySelector('use');
    copyText(url).then(() => {
      icon?.setAttribute('href', '#ph-check');
      copyButton.classList.add('is-copied');
      copyButton.setAttribute('aria-label', 'Link copied');
      if (copyStatus) copyStatus.textContent = 'Link copied to clipboard';
    }).catch(() => {
      if (copyStatus) copyStatus.textContent = 'Could not copy the link';
    }).finally(() => {
      clearTimeout(copyTimer);
      copyTimer = setTimeout(() => {
        icon?.setAttribute('href', '#ph-link');
        copyButton.classList.remove('is-copied');
        copyButton.setAttribute('aria-label', 'Copy article link');
        if (copyStatus) copyStatus.textContent = '';
      }, 2000);
    });
  });
})();
